function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import angular from 'angular';
import { AccesoDatos } from 'src/_candidato/comun/services/acceso-datos';
import { TiposDocEstadosStore } from 'src/_candidato/data/tiposStore';
import { BusquedaCV } from '../../model/busqueda-cv';
import { BaseFeaturesComponent } from '../_base/base-features.component';
var PanelCurriculumsComponentCtrl = /*#__PURE__*/function (_BaseFeaturesComponen) {
  PanelCurriculumsComponentCtrl.$inject = ["$element", "$log", "$timeout", "AccesoDatos", "appConfigService"];
  function PanelCurriculumsComponentCtrl($element, $log, $timeout, AccesoDatos, appConfigService) {
    var _this;
    _classCallCheck(this, PanelCurriculumsComponentCtrl);
    _this = _callSuper(this, PanelCurriculumsComponentCtrl, [appConfigService]);
    _defineProperty(_this, "busqueda", new BusquedaCV());
    _defineProperty(_this, "$loading", false);
    _defineProperty(_this, "panelcv", {
      $visible: false,
      cv: null
    });
    _defineProperty(_this, "columnaMiddleMan", true);
    _this.$element = $element;
    _this.$log = $log;
    _this.$timeout = $timeout;
    _this.AccesoDatos = AccesoDatos;
    return _this;
  }
  _inherits(PanelCurriculumsComponentCtrl, _BaseFeaturesComponen);
  return _createClass(PanelCurriculumsComponentCtrl, [{
    key: "$onInit",
    value: function $onInit() {
      var _this2 = this;
      this.$log.info('[PanelCurriculumsComponentCtrl] onInit');

      // al inicio, obtener los ítems de menú disponibles, no solo los visibles
      this.AccesoDatos.GestionCurr_CLIENT.opcionesSeleccionCurriculums().then(function (selResponse) {
        _this2.selecciones = selResponse.listaSelecciones;
      });
      this.AccesoDatos.Datos_Client.tiposParaDocuemntos().then(function (tiposResponse) {
        return _this2.datosTipos = new TiposDocEstadosStore(tiposResponse);
      });
      this.columnaMiddleMan = this.usercfg && this.usercfg.adm && this.usercfg.options.app === 'MODIFCONTRATOS';
    }
  }, {
    key: "listacv",
    value: function listacv() {
      if (this.usercfg.adm) this.AccesoDatos.GestionCurr_CLIENT.lastCV();else this.AccesoDatos.GestionSolicitudes_CLIENT.lastCV();
    }
  }, {
    key: "busquedacv",
    value: function busquedacv() {
      var _this3 = this;
      this.$loading = true;
      this.listado = null;
      this._callbackBusqueda(this.busqueda.generaFiltros()).then(function (listadoResponse) {
        _this3.$log.info('listado', listadoResponse);
        _this3.listado = listadoResponse;
        _this3.listadolist = listadoResponse.list;
      });
    }
  }, {
    key: "_callbackBusqueda",
    value: function _callbackBusqueda(filtros) {
      if (this.usercfg.adm) return this.AccesoDatos.GestionCurr_CLIENT.findCV(filtros);else return this.AccesoDatos.GestionSolicitudes_CLIENT.findCV(filtros);
    }
  }, {
    key: "seleccionaForm",
    value: function seleccionaForm() {
      var _this4 = this;
      // obtener las preguntas del formulario
      this.AccesoDatos.GestionCurr_CLIENT.pregsSeleccionCurriculums(this.busqueda.opt.item.idm).then(function (formResponse) {
        _this4.busqueda.pregslist = formResponse.listPreguntas;
        _this4.busqueda.selMenu(_this4.busqueda.opt.item);
        // generar una nueva selección de pregunta
        // this.busqueda.nuevaCondicion()
      });
    }
  }, {
    key: "otraCondicion",
    value: function otraCondicion() {
      this.busqueda.nuevaCondicionPregunta();
    }
  }, {
    key: "filtroEstado",
    value: function filtroEstado() {
      this.busqueda.estado = true;
      this.busqueda.nuevaCondicionEstado();
    }
  }, {
    key: "filtroFechas",
    value: function filtroFechas() {
      this.busqueda.fechas = true;
      this.busqueda.nuevaCondicionFechas();
    }
  }, {
    key: "accesscv",
    value: function accesscv(idx) {
      this.$log.debug('access', this.listado.list[idx]);
      this.panelcv.cv = this.listado.list[idx];
      this.panelcv.$visible = true;
    }
  }, {
    key: "exportcv",
    value: function exportcv() {}
  }, {
    key: "clearForm",
    value: function clearForm() {
      this.busqueda = new BusquedaCV();
    }
  }, {
    key: "quitarCondicion",
    value: function quitarCondicion(idx) {
      this.busqueda.quitarCondicion(idx);
    }
  }]);
}(BaseFeaturesComponent);
angular.module('candidato').component('panelCurriculums', {
  bindings: {},
  controller: PanelCurriculumsComponentCtrl,
  template: require('./panel-curriculums.component.html')
  //templateUrl: "../../../../app/ui/vs/prog/dev/templates/panel-curriculums/panel-curriculums.component.html"
});
angular.module('candidato').filter('datestr', ["$log", function ($log) {
  return function (datestr) {
    if (!datestr) return '';
    $log.debug('====> datestr ', datestr);
    return new Date(datestr).toLocaleDateString('es');
  };
}]);